import {
  measuredUsingConfigFor as wrapAsMeasuredUsingConfig,
  mergeConfig,
  wrapAsDerivedFromMeasurementsConfig,
} from 'Components/Worksheets/Core/Helpers/configHelpers';
import { DispersionApparatusType, WashingProcedure } from 'Components/Worksheets/WashWorksheet/types';
import qestIds from '../../../../QestIds';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Preparation.WashingProcedure`]: {
        options: [
          { label: 'A', value: WashingProcedure.WashWithPlainWater },
          { label: 'B', value: WashingProcedure.WashWithWaterAndAgent },
        ],
      },
      [`${prefix}.Preparation.DispersionApparatus`]: {
        options: [
          { label: 'None', value: DispersionApparatusType.None },
          { label: 'Ultrasonic', value: DispersionApparatusType.Ultrasonic },
          { label: 'Shaken', value: DispersionApparatusType.Shaken },
        ],
      },
      [`${prefix}.Preparation.SoakingPeriod`]: { uom: 'min', format: { nearest: 0.1 } },
      [`${prefix}.Masses.InitialDryMass`]: { uom: 'g', format: { nearest: 0.1 } },
      [`${prefix}.Masses.WashingsDryMass`]: { uom: 'g', format: { nearest: 0.1 } },
      [`${prefix}.Results.PercentPassingWashingSieve`]: { format: { nearest: 0.1 } },
    },
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    {
      [`${prefix}.Equipment.WashedBalance`]: { defaultReadability: 0.1, defaultUom: 'g' },
    }
  );

const getMeasuredUsingConfig = (prefix: string) => {
  const washedBalance = wrapAsMeasuredUsingConfig(`${prefix}.Equipment.WashedBalance`);

  return {
    [`${prefix}.Masses.InitialTareMass`]: washedBalance,
    [`${prefix}.Masses.WashedTareAndDryMass`]: washedBalance,
  };
};

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.Masses.WashedDryMass`]: wrapAsDerivedFromMeasurementsConfig([
    `${prefix}.Masses.InitialTareMass`,
    `${prefix}.Masses.WashedTareAndDryMass`,
  ]),
});

export { getConfig };

export default {
  [qestIds.wash.ASTM_D6913.rev2017]: getConfig,
};
